import { api } from './api';
import store from '@/store';
import ReportsOfSickness from '@/resources/constants/reports-of-sickness';

const setIsLoading = function (type, value) {
  store.commit(ReportsOfSickness.Mutations.IsLoading.SET, {
    type: type,
    value: value
  });
};

export default {
  Create (reportOfSicknessId, uwvDecision) {
    const endpoint = encodeURI(
      ReportsOfSickness.Endpoints.UwvDecisions.Create(reportOfSicknessId));

    setIsLoading('UWV_DECISION_CREATE', true);
    return api.post(endpoint, uwvDecision.getCreateModel())
      .finally(() => setIsLoading('UWV_DECISION_CREATE', false));
  }

  /*
  Delete (reportOfSicknessId, uwvDecision) {
    const endpoint = encodeURI(
      ReportsOfSickness.Endpoints.UwvDecisions.Delete(reportOfSicknessId, uwvDecision.id));

    setIsLoading('UWV_DECISION_DELETE', true);
    return axios.delete(endpoint)
      .finally(() => setIsLoading('UWV_DECISION_DELETE', false));
  },

  Update (reportOfSicknessId, uwvDecision) {
    const endpoint = encodeURI(
      ReportsOfSickness.Endpoints.UwvDecisions.Update(reportOfSicknessId, uwvDecision.id));
    const options = { 'Content-Type': 'multipart/form-data' };

    setIsLoading('UWV_DECISION_UPDATE', true);
    return axios.put(endpoint, uwvDecision.getBody(), options)
      .finally(() => setIsLoading('UWV_DECISION_UPDATE', false));
  } */
};
